import React from "react";
import "./Spinner.scss";
import Lottie from "lottie-react";
import Loading from './Loading.json'
const Spinner = props => (
  <div className={"LoaderWrapper " + (props.size ? props.size : "")}>
    {/* <div className={"Loader " + (props.theme ? props.theme : "")}>Loading...</div> */}
    <Lottie className={'spinner-new Loader'} animationData={Loading} loop={true} />
  </div>
);

export default Spinner;
